import { createContext, ReactNode } from "react";

import { SessionCurrentUser } from "@/types/users";
import { Workspace } from "@/types/workspaces";

export interface AuthContextType {
  currentUser: SessionCurrentUser;
  currentWorkspace: Workspace;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

interface AuthContextProviderProps {
  currentUser: SessionCurrentUser;
  currentWorkspace: Workspace;
  children: ReactNode;
}

export function AuthContextProvider({
  currentUser,
  currentWorkspace,
  children,
}: AuthContextProviderProps) {
  return (
    <AuthContext.Provider value={{ currentUser, currentWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
}
